import { Link } from 'react-router-dom';

interface CategoryCTAProps {
  slug: string;
  categoryName: string;
}

export default function CategoryCTA({ slug, categoryName }: CategoryCTAProps) {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
          订阅{categoryName}漫画更新
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-6 max-w-md mx-auto">
          第一时间获取最新{categoryName}韩漫上架通知，不错过任何精彩
        </p>
        <Link
          to={`/category/${slug}`}
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}